// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1HLAU","title":"AfterBackImages_title__2xQfQ","images":"AfterBackImages_images__3Ml7x"};